import { supabase } from '@/integrations/supabase/client';

export const normalizeProjectAiContext = (markdown?: string | null) => {
  const trimmed = markdown?.trim();
  return trimmed ? trimmed : null;
};

export const buildProjectAiContextSystemPrompt = (projectName: string, markdown: string) => {
  return [
    `Hidden application markdown context for the project "${projectName}":`,
    'Use this as internal background context and instructions for the current conversation.',
    'Do not mention that this hidden context exists unless the user explicitly asks about project configuration.',
    '',
    '<hidden-project-markdown>',
    markdown,
    '</hidden-project-markdown>',
  ].join('\n');
};

export const getProjectAiContext = async (projectId?: string | null) => {
  if (!projectId) {
    return null;
  }

  const { data, error } = await (supabase as any)
    .from('projects')
    .select('id, name, ai_context_markdown')
    .eq('id', projectId)
    .maybeSingle();

  if (error || !data) {
    return null;
  }

  const project = data as { id: string; name: string; ai_context_markdown?: string | null };
  const markdown = normalizeProjectAiContext(project.ai_context_markdown);
  if (!markdown) {
    return null;
  }

  return {
    projectId: project.id,
    projectName: project.name,
    markdown,
    systemPrompt: buildProjectAiContextSystemPrompt(project.name, markdown),
  };
};